import { get as _get, find as _find } from 'lodash';

const findAndGet = (objectToSearchIn, searchPath, keyToSearchFor, resultPath, defaultResult) => {
  const targetObject = _find(objectToSearchIn, [searchPath, keyToSearchFor]);
  return _get(targetObject, resultPath, defaultResult);
};

export { findAndGet }; // eslint-disable-line import/prefer-default-export
